import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-groups-page',
    templateUrl: './user-groups-page.component.html',
    styleUrls: ['./user-groups-page.component.css'],
    standalone: false
})
export class UserGroupsPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
